// Mock data for the website
export const brand = {
  name: "Klartech Müritz",
  phone: "+49 1512 8958006",
  email: "kontakt@klartech-mueritz.de",
  contact: {
    location: "Waren (Müritz)",
    phone: "+49 1512 8958006",
    email: "kontakt@klartech-mueritz.de",
    address: "Waren (Müritz)"
  },
  colors: {
    primary: "#0891b2",
    primaryDark: "#0e7490",
    accent: "#06b6d4",
    muted: "#94a3b8"
  }
};

export const legal = {
  companyName: "Klartech Müritz",
  owner: "Inhaber",
  address: "Waren (Müritz)",
  phone: "+49 1512 8958006",
  email: "kontakt@klartech-mueritz.de",
  impressum: {
    company: "Klartech Müritz",
    name: "Inhaber",
    address: ["Waren (Müritz)", "Deutschland"],
    phone: "+49 1512 8958006",
    email: "kontakt@klartech-mueritz.de",
    notes: [
      "Alle Texte und Inhalte dieser Website sind urheberrechtlich geschützt.",
      "Die Nutzung der Kontaktdaten für gewerbliche Werbung ist untersagt."
    ]
  },
  datenschutz: {
    sections: [
      { h: "Verantwortlicher", p: "Klartech Müritz, Waren (Müritz)" },
      { h: "Datenerhebung", p: "Wir erheben personenbezogene Daten nur im erforderlichen Umfang." },
      { h: "Kontaktformular", p: "Bei Nutzung des Kontaktformulars werden Ihre Angaben zur Bearbeitung gespeichert." },
      { h: "Ihre Rechte", p: "Sie haben das Recht auf Auskunft, Berichtigung und Löschung Ihrer Daten." }
    ]
  }
};

export const nav = [
  { label: "Home", href: "#home" },
  { label: "Leistungen", href: "#leistungen" },
  { label: "Preise", href: "#preise" },
  { label: "Kontakt", href: "#kontakt" }
];

export const benefits = [
  { title: "Lokal", desc: "Vor-Ort-Service in Waren und Umgebung" },
  { title: "Verständlich", desc: "Keine Fachsprache - klare Erklärungen" },
  { title: "Geduldig", desc: "Individuelle Betreuung ohne Zeitdruck" },
  { title: "Zuverlässig", desc: "Termingerechte und verlässliche Hilfe" },
  { title: "Transparent", desc: "Faire Preise ohne versteckte Kosten" },
  { title: "Flexibel", desc: "Remote oder vor Ort - wie Sie möchten" }
];

export const services = {
  business: {
    title: "Business & Home-Office",
    bullets: [
      "PC- und Netzwerk-Einrichtung",
      "Office-Anwendungen und Email",
      "Datensicherung und Cloud-Setup",
      "Drucker und Scanner Installation"
    ]
  },
  seniors: {
    title: "Senioren-freundliche IT-Hilfe",
    bullets: [
      "Smartphone und Tablet Einrichtung",
      "WhatsApp und Video-Telefonie",
      "Online-Banking Unterstützung",
      "Sicherheit im Internet"
    ]
  }
};

export const workTimes = {
  headline: "Wichtiger Hinweis zu Arbeitszeiten & Vor-Ort-Terminen",
  intro: "Ich arbeite überwiegend remote und bin in der Regel Montag bis Freitag von 8:00–17:00 Uhr erreichbar. Vor-Ort-Termine nach Absprache, primär in den Abendstunden.",
  slots: [
    { day: "Mo, Di, Do, Fr", time: "Vor-Ort abends möglich" },
    { day: "Mittwoch", time: "Keine Vor-Ort-Termine" },
    { day: "Samstag", time: "In Ausnahmefällen nach Vereinbarung" },
    { day: "So & Feiertage", time: "Keine Vor-Ort-Termine" }
  ],
  note: "Telefonische Erreichbarkeit: Mo–Fr 8:00–17:00 Uhr"
};

export const faqs = [
  { q: "Wie schnell können Sie helfen?", a: "In der Regel innerhalb von 24-48 Stunden." },
  { q: "Kommen Sie auch nach Hause?", a: "Ja, ich biete Vor-Ort-Service in Waren und Umgebung." },
  { q: "Was kostet eine Stunde?", a: "Die Preise finden Sie in unserer Preisliste." }
];

export const images = {
  hero: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800",
  business: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=800",
  seniorAlt: "https://images.unsplash.com/photo-1516321497487-e288fb19713f?w=800",
  remote: "https://images.unsplash.com/photo-1587440871875-191322ee64b0?w=800"
};

export const prices = [
  { name: "Remote Support", price: "45 €/Std.", description: "Fernwartung via TeamViewer" },
  { name: "Vor-Ort Service", price: "55 €/Std.", description: "Bei Ihnen zuhause oder im Büro" },
  { name: "Erstberatung", price: "Kostenlos", description: "30 Min. telefonische Beratung" }
];

export const remoteSupport = {
  headline: "Schnelle Hilfe per Remote-Support",
  intro: "Direkte Unterstützung auf Ihrem Bildschirm - bequem von zuhause aus.",
  bullets: [
    "Keine Wartezeit auf Techniker",
    "Sichere verschlüsselte Verbindung",
    "Sie sehen jeden Schritt mit"
  ]
};

export default { brand, legal, nav, benefits, services, workTimes, faqs, images, prices, remoteSupport };
